import { Form, FormikProvider, useFormik } from 'formik';
import { Button, Card, Checkbox, Stack, TextField, Typography } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import InnerForm from './InnerForm';

export default function InnerBody() {
  const [fields, setFields] = useState(null);
  const [checkDisable, setCheckDisable] = useState(false);

  const [value, setValue] = useState({ 11: 0 });

  const NewUserSchema = Yup.object().shape({
    noOfSegment: Yup.number().required('*Please enter No. of Aging Buckets')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      noOfAgingBuckets: ''
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        setFields(parseInt(values.noOfAgingBuckets, 10));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });
  const { errors, touched, handleSubmit, getFieldProps } = formik;

  const handleChange = (event) => {
    const { key } = event;
    const { name } = event.target;
    if (name === 'agingBuckets') {
      if (key === 'Backspace' || key === 'Delete') {
        console.log('BackValue', event.target.value);
        setFields(0);
        console.log('BackSpace', fields);
      }
      if (key === 'Enter') {
        setFields(parseInt(event.target.value, 10));
        console.log('BackSEnter', fields);
      }

      console.log('name', name);
      if (name === 'checkBox') {
        if (key === 'checked') {
          console.log('event', event);
          setFields(true);
        }
      }
    } else if (name === 'accountExpire') {
      console.log('name', name);
    }
  };
  console.log(fields);
  return (
    <FormikProvider value={formik}>
      {/* <Form noValidate autoComplete="off" onSubmit={handleSubmit}> */}
      {/* <Card sx={{ p: 3 }}> */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 3, sm: 2 }}
        sx={{ marginTop: 2 }}
        alignItems="center"
      >
        <TextField
          fullWidth
          name="accountExpire"
          onChange={handleChange}
          label="Expiration Of Accounts ( in Days )"
          disabled={checkDisable}
        />
        {/* <Checkbox name="checkBox" onChange={() => setCheckDisable(!checkDisable)} /> */}
        {/* <Typography>No Expiration</Typography> */}
      </Stack>
      <Stack sx={{ marginTop: 2 }}>
        <TextField
          name="agingBuckets"
          onChange={handleChange}
          onKeyDown={handleChange}
          // value={fields}
          label="Number of Payment Aging Buckets"
        />
      </Stack>
      <Stack sx={{ marginTop: 4 }}>
        <h4>Aging Buckets</h4>
      </Stack>
      {(fields !== null || Number.isNaN(fields)) &&
        [...Array(fields - 1)].map((data, index) => <InnerForm index={index} setValue={setValue} value={value} />)}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ marginTop: 2 }}>
        <TextField fullWidth value={value[`${fields}1`]} disabled />
      </Stack>
      <Stack direction="row-reverse">
        <LoadingButton variant="outlined" direction={{ xs: 'column', sm: 'row' }} sx={{ marginTop: 2 }}>
          Save
        </LoadingButton>
      </Stack>
      {/* </Card> */}
      {/* </Form> */}
    </FormikProvider>
  );
}
